module.exports = __webpack_public_path__ + "why6.png?eab109b52a72fce302e236d83029ef09";